module.exports = __webpack_public_path__ + "static/how to install jitsi meet-3222b21ec1e1ac2b08aa210d2de1d7fb.png";